import React, { useState } from "react"
import tw, { styled, css } from "twin.macro"
import { useTranslation } from "next-i18next"
import { ReactComponent as CopyLinkSVG } from "../../../assets/input/copy-link.svg"

interface StyledProps {
  hoveredIcon?: boolean
  clickedIcon?: boolean
}

const CopyLinkIcon = styled(CopyLinkSVG)(() => [tw`absolute mx-4 right-0 top-2.5 h-6 w-6 cursor-pointer`])
const Tooltip = styled.span(({ hoveredIcon, clickedIcon }: StyledProps) => [
  tw`absolute border-2 border-base-3 bg-base-1 text-base-4 p-1 rounded-md ml-2 -top-2 right-[-50px] hidden`,
  css`
    ::after {
      ${tw`absolute -ml-2`}
      content: "";
      top: 100%;
      left: 50%;
      border-width: 5px;
      border-color: #a5afd7 transparent transparent transparent;
    }
  `,
  hoveredIcon && tw`block`,
  clickedIcon && tw`-right-3`,
])

interface CopyLinkProps {
  username: string
}
const CopyLink = ({ username }: CopyLinkProps) => {
  const [hoveredIcon, setHoveredIcon] = useState(false)
  const [clickedIcon, setClickedIcon] = useState(false)
  const { t } = useTranslation("editProfile")

  return (
    <>
      <CopyLinkIcon
        onMouseOver={() => setHoveredIcon(true)}
        onMouseLeave={() => setHoveredIcon(false)}
        onClick={async () => {
          setClickedIcon(true)
          await navigator.clipboard.writeText(`https://joinbonsai.co/${username}`)
        }}
      />
      <Tooltip hoveredIcon={hoveredIcon} clickedIcon={clickedIcon}>
        {clickedIcon ? t("tooltip_clicked") : t("tooltip")}
      </Tooltip>
    </>
  )
}
export default CopyLink
